'use strict';

var FbcApplicabilityChartAggregationFactory = function FbcApplicabilityChartAggregationFactory(DataAggregationFactory) {
  function FbcApplicabilityChartAggregation() {
    DataAggregationFactory.call(this, 'fares-mode', 'fbc-applicability-chart');
  }
  FbcApplicabilityChartAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FbcApplicabilityChartAggregation.constructor = FbcApplicabilityChartAggregation;
  FbcApplicabilityChartAggregation.prototype.aggregate = function (data) {
    return data;
  };
  return FbcApplicabilityChartAggregation;
};
FbcApplicabilityChartAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = FbcApplicabilityChartAggregationFactory;